!function() {
  "use strict";
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r = [], n = false, a = null;
  const o = (e2) => Date.now() - e2 > 3e5, i = async ({ shopDomain: e2, accessToken: t2, query: r2, variables: n2 }) => {
    try {
      const a2 = `https://${e2}/api/2024-07/graphql.json`, o2 = { "X-Shopify-Storefront-Access-Token": t2, "Content-Type": "application/json" }, i2 = await fetch(a2, { method: "POST", headers: o2, body: JSON.stringify({ query: r2, variables: n2 }) });
      return await i2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, c = async (i2, c2, l2, p2, u2, d2) => {
    const y2 = ((e2, t2, r2, n2, a2) => `${e2}:${t2}:${r2}:${JSON.stringify(n2)}:${a2}`)(i2, l2, p2, u2, d2), m2 = e.get(y2);
    if (m2 && !o(m2.timestamp)) return m2.data;
    const g2 = t.get(y2);
    if (g2) return g2;
    const f2 = (h2 = { shopDomain: i2, accessToken: c2, handle: l2, customerGroupId: p2, customerTags: u2, clayCountryIsoCode: d2, cacheKey: y2 }, new Promise((e2, t2) => {
      r.push({ ...h2, resolve: e2, reject: t2 }), n || (n = true, queueMicrotask(() => {
        n = false, function() {
          if (0 === r.length) return;
          const e3 = r;
          r = [];
          for (let t3 = 0; t3 < e3.length; t3 += 10) {
            const r2 = e3.slice(t3, t3 + 10), n2 = null === a, o2 = s(r2, n2);
            n2 && (a = o2);
          }
        }();
      }));
    }));
    var h2;
    return t.set(y2, f2), f2.finally(() => {
      t.delete(y2);
    }), f2;
  };
  async function s(t2, r2) {
    var _a, _b, _c;
    if (!r2 && a) try {
      await a;
    } catch {
    }
    const n2 = t2[0];
    try {
      const r3 = `query batchProductMetafield($country: CountryCode) @inContext(country: $country) {
    ${t2.map((e2) => e2.handle).map((e2, t3) => `p${t3}: product(handle: ${JSON.stringify(e2)}) {
      title
      handle
      variants(first: 50) {
        edges {
          node {
            id
            title
            metafield(namespace: "app--173437812737--clay", key: "pricing_rule") {
              value
              type
            }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
            availableForSale
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }`).join("\n")}
  }`, a2 = await i({ shopDomain: n2.shopDomain, accessToken: n2.accessToken, query: r3, variables: { country: n2.clayCountryIsoCode } });
      if (!(a2 == null ? void 0 : a2.data)) {
        const e2 = new Error("Empty response from Storefront API");
        return void t2.forEach((t3) => t3.reject(e2));
      }
      for (let r4 = 0; r4 < t2.length; r4++) {
        const n3 = t2[r4], o2 = a2.data[`p${r4}`];
        if (!o2) {
          const t3 = { handle: n3.handle, allVariants: [] };
          e.set(n3.cacheKey, { data: t3, timestamp: Date.now() }), n3.resolve(t3);
          continue;
        }
        if ((_b = (_a = o2.variants) == null ? void 0 : _a.pageInfo) == null ? void 0 : _b.hasNextPage) {
          p(n3.shopDomain, n3.accessToken, n3.handle, n3.customerGroupId, n3.customerTags, n3.clayCountryIsoCode, n3.cacheKey).then((e2) => n3.resolve(e2)).catch(n3.reject);
          continue;
        }
        const i2 = (((_c = o2.variants) == null ? void 0 : _c.edges) || []).map((e2) => l(e2.node, n3.customerGroupId, n3.customerTags)), c2 = { handle: n3.handle, allVariants: i2 };
        e.set(n3.cacheKey, { data: c2, timestamp: Date.now() }), n3.resolve(c2);
      }
      u();
    } catch (e2) {
      console.error("Error in batched product metafield fetch:", e2), t2.forEach((t3) => t3.reject(e2));
    }
  }
  function l(e2, t2, r2) {
    var _a;
    const n2 = e2.id.split("/").pop(), a2 = (_a = e2.metafield) == null ? void 0 : _a.value, o2 = function(e3) {
      if (!Array.isArray(e3) || 0 === e3.length) return [];
      const t3 = e3[0];
      if ("customerGroupId" in t3) return r3 = e3, Array.isArray(r3) ? r3.map((e4 = {}) => {
        const { customerGroupId: t4 = "", customerTag: r4 = "", type: n3 = "WHOLESALE", wholesalePrice: a3 = null, quantityPrice: o3 = {} } = e4;
        let i3 = false;
        "QUANTITY" === n3 && (i3 = !!o3.isVariantUnique);
        let c3 = [];
        return "WHOLESALE" === n3 && null != a3 ? c3.push({ quantity: "1", price: a3 }) : Array.isArray(o3.value) && (c3 = o3.value), { ownerId: "", customerGroupId: t4, customerTag: r4, markets: [{ handle: "", currency: "", pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: i3, priceSource: "R", values: c3 } }] };
      }) : [];
      var r3;
      if ("i" in t3) return function(e4) {
        if (!e4 || !Array.isArray(e4)) return null;
        const t4 = e4.map((e5 = {}) => {
          let t5 = e5.o || "", [r4 = "", n3 = ""] = (e5.i || "").split("~"), a3 = e5.p.split("|").map((e6) => {
            let [t6 = "", r5 = "", n4 = "A", a4 = "0", o3 = "R", i3 = ""] = e6.split("~"), c3 = i3.split(";").map((e7) => {
              let [t7 = "1", r6 = "0"] = e7.split(":");
              return { quantity: t7, price: r6 };
            }) ?? [];
            return { handle: t6, currency: r5, pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: n4, priceSource: o3, isVariantUnique: "1" === a4, values: c3 } };
          });
          return { ownerId: t5, customerGroupId: r4, customerTag: n3, markets: a3 };
        });
        return t4;
      }(e3);
      return [];
    }("string" == typeof a2 ? JSON.parse(a2) : []);
    let i2 = o2.find((e3) => e3.customerGroupId === t2 && !["LOGGED_IN", "ALL"].includes(t2) || r2.includes(e3.customerTag));
    i2 || "ALL" === t2 || (i2 = o2.find((e3) => "LOGGED_IN" === e3.customerGroupId)), i2 || (i2 = o2.find((e3) => "ALL" === e3.customerGroupId));
    const c2 = window.clayMarketHandle;
    if (i2) {
      const t3 = i2.markets.find((e3) => e3.handle === c2 || "" === e3.handle) || null;
      if (t3) {
        const r3 = { ...i2, markets: [t3] };
        if ("" === r3.ownerId || r3.ownerId === n2.split("/").pop()) return { id: n2, title: e2.title, pricingRule: r3, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
      }
    }
    return { id: n2, title: e2.title, pricingRule: null, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
  }
  async function p(t2, r2, n2, a2, o2, c2, s2) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    try {
      let p2, d2 = true;
      const y2 = [];
      for (; d2; ) {
        const u2 = await i({ shopDomain: t2, accessToken: r2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250, after: ${p2 ? `"${p2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                    availableForSale
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: n2, country: c2 } });
        if (!((_a = u2.data) == null ? void 0 : _a.product)) {
          const t3 = { handle: n2, allVariants: [] };
          return e.set(s2, { data: t3, timestamp: Date.now() }), t3;
        }
        const m3 = (((_b = u2.data.product.variants) == null ? void 0 : _b.edges) || []).map((e2) => l(e2.node, a2, o2));
        y2.push(...m3), d2 = (_f = (_e = (_d = (_c = u2.data) == null ? void 0 : _c.product) == null ? void 0 : _d.variants) == null ? void 0 : _e.pageInfo) == null ? void 0 : _f.hasNextPage, p2 = (_j = (_i = (_h = (_g = u2.data) == null ? void 0 : _g.product) == null ? void 0 : _h.variants) == null ? void 0 : _i.pageInfo) == null ? void 0 : _j.endCursor;
      }
      const m2 = { handle: n2, allVariants: y2 };
      return e.set(s2, { data: m2, timestamp: Date.now() }), u(), m2;
    } catch (e2) {
      throw console.error("Error fetching product metafield:", e2), e2;
    }
  }
  const u = () => {
    for (const [t2, r2] of e.entries()) o(r2.timestamp) && e.delete(t2);
  };
  function d(e2, t2) {
    if (null === e2) return "";
    const r2 = "string" == typeof e2 ? parseFloat(e2) : e2, n2 = r2.toFixed(2), a2 = r2.toFixed(0), o2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), i2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), s2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), l2 = n2.replace(".", ","), p2 = o2.replace(/(\d+)\.(\d{2})$/, "$1,$2"), u2 = c2.replace(/(\d+)\.(\d{2})$/, "$1,$2");
    return t2.replace("{{amount}}", n2).replace("{{amount_no_decimals}}", a2).replace("{{amount_with_comma_separator}}", o2).replace("{{amount_no_decimals_with_comma_separator}}", i2).replace("{{amount_with_period_separator}}", c2).replace("{{amount_no_decimals_with_period_separator}}", s2).replace("{{amount_with_comma_decimal}}", l2).replace("{{amount_with_comma_separator_and_comma_decimal}}", p2).replace("{{amount_with_period_separator_and_comma_decimal}}", u2);
  }
  function y(e2, t2, r2) {
    var _a;
    let n2 = "", a2 = "", o2 = "", i2 = "", c2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!c2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let s2 = c2.pricing.type;
    return "QUANTITY" === s2 ? { retailPriceText: n2, compareAtPriceText: a2, savingsText: o2, maxRetailPriceText: i2 } = function(e3, t3, r3, n3) {
      let a3 = n3.pricing.strategy, o3 = n3.pricing.values, i3 = n3.currency, c3 = e3.price.currencyCode, s3 = "R" === n3.pricing.priceSource ? e3.price.amount : "C" === n3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l2 = window.marketConversionRate;
      if (!s3 || "" === s3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let p2 = o3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (i3 !== c3 && "" !== i3) {
        if (!l2 || !l2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(a3) && (p2 = (parseFloat(p2) * l2.conversion_rate).toFixed(2).toString());
      }
      let u2 = "A" === a3 ? p2 : "P" === a3 ? (parseFloat(s3) * (1 - parseFloat(p2) / 100)).toFixed(2).toString() : "F" === a3 ? (parseFloat(s3) - parseFloat(p2)).toFixed(2).toString() : e3.price.amount;
      if ("" === i3 && l2 && l2.base_currency !== c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(u2) < 0 || parseFloat(u2) > parseFloat(e3.price.amount)) && (u2 = e3.price.amount);
      let y2 = d(u2, clayProductPriceConfig.priceDisplayText), m2 = d(s3, clayProductPriceConfig.compareAtPriceDisplayText), g2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(s3) - parseFloat(u2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(s3) - parseFloat(u2)) / parseFloat(s3) * 100).toFixed(2) : 0, f2 = d(g2, clayProductPriceConfig.savingsDisplayText);
      return l2 && (y2 = window.clayCurrencySymbol + parseFloat(u2).toFixed(2) + " " + window.clayCountryCurrency, m2 = window.clayCurrencySymbol + parseFloat(s3).toFixed(2) + " " + window.clayCountryCurrency, f2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + g2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? g2 + "%" : "")), { retailPriceText: y2, compareAtPriceText: m2, savingsText: f2, maxRetailPriceText: "" };
    }(e2, 0, r2, c2) : "WHOLESALE" === s2 && ({ retailPriceText: n2, compareAtPriceText: a2, savingsText: o2, maxRetailPriceText: i2 } = function(e3, t3, r3) {
      let n3 = r3.pricing.strategy;
      r3.pricing.values;
      let a3 = r3.currency, o3 = e3.price.currencyCode, i3 = window.marketConversionRate, c3 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s3 = r3.pricing.values[0].price;
      if (!c3 || "" === c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (a3 !== o3 && "" !== a3) {
        if (!i3 || !i3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(n3) && (s3 = (parseFloat(s3) * i3.conversion_rate).toFixed(2).toString());
      }
      let l2 = "A" === n3 ? s3 : "P" === n3 ? (parseFloat(c3) * (1 - parseFloat(s3) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c3) - parseFloat(s3)).toFixed(2).toString() : e3.price.amount;
      if ("" === a3 && i3 && i3.base_currency !== o3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(l2) < 0 || parseFloat(l2) > parseFloat(e3.price.amount)) && (l2 = e3.price.amount);
      let p2 = d(l2, clayProductPriceConfig.priceDisplayText), u2 = d(c3, clayProductPriceConfig.compareAtPriceDisplayText), y2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c3) - parseFloat(l2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c3) - parseFloat(l2)) / parseFloat(c3) * 100).toFixed(2) : 0, m2 = d(y2, clayProductPriceConfig.savingsDisplayText);
      return i3 && (p2 = window.clayCurrencySymbol + parseFloat(l2).toFixed(2) + " " + window.clayCountryCurrency, u2 = window.clayCurrencySymbol + parseFloat(c3).toFixed(2) + " " + window.clayCountryCurrency, m2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + y2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? y2 + "%" : "")), { retailPriceText: p2, compareAtPriceText: u2, savingsText: m2, maxRetailPriceText: "" };
    }(e2, 0, c2)), { retailPriceText: n2, compareAtPriceText: a2, savingsText: o2, maxRetailPriceText: i2 };
  }
  function m(e2) {
    if (!e2 || "" === e2) return null;
    let t2 = null;
    const r2 = e2.match(/\/products\/([^/?#]+)/);
    return r2 && r2[1] && (t2 = decodeURIComponent(r2[1])), t2;
  }
  const g = "%[a-f0-9]{2}", f = new RegExp("(" + g + ")|([^%]+?)", "gi"), h = new RegExp("(" + g + ")+", "gi");
  function w(e2, t2) {
    try {
      return [decodeURIComponent(e2.join(""))];
    } catch {
    }
    if (1 === e2.length) return e2;
    t2 = t2 || 1;
    const r2 = e2.slice(0, t2), n2 = e2.slice(t2);
    return Array.prototype.concat.call([], w(r2), w(n2));
  }
  function b(e2) {
    try {
      return decodeURIComponent(e2);
    } catch {
      let t2 = e2.match(f) || [];
      for (let r2 = 1; r2 < t2.length; r2++) t2 = (e2 = w(t2, r2).join("")).match(f) || [];
      return e2;
    }
  }
  function x(e2) {
    if ("string" != typeof e2) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e2 + "`");
    try {
      return decodeURIComponent(e2);
    } catch {
      return function(e3) {
        const t2 = { "%FE%FF": "��", "%FF%FE": "��" };
        let r2 = h.exec(e3);
        for (; r2; ) {
          try {
            t2[r2[0]] = decodeURIComponent(r2[0]);
          } catch {
            const e4 = b(r2[0]);
            e4 !== r2[0] && (t2[r2[0]] = e4);
          }
          r2 = h.exec(e3);
        }
        t2["%C2"] = "�";
        const n2 = Object.keys(t2);
        for (const r3 of n2) e3 = e3.replace(new RegExp(r3, "g"), t2[r3]);
        return e3;
      }(e2);
    }
  }
  function v(e2, t2) {
    const r2 = {};
    if (Array.isArray(t2)) for (const n2 of t2) {
      const t3 = Object.getOwnPropertyDescriptor(e2, n2);
      (t3 == null ? void 0 : t3.enumerable) && Object.defineProperty(r2, n2, t3);
    }
    else for (const n2 of Reflect.ownKeys(e2)) {
      const a2 = Object.getOwnPropertyDescriptor(e2, n2);
      if (a2.enumerable) {
        t2(n2, e2[n2], e2) && Object.defineProperty(r2, n2, a2);
      }
    }
    return r2;
  }
  function P(e2, t2) {
    if ("string" != typeof e2 || "string" != typeof t2) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === e2 || "" === t2) return [];
    const r2 = e2.indexOf(t2);
    return -1 === r2 ? [] : [e2.slice(0, r2), e2.slice(r2 + t2.length)];
  }
  const T = Symbol("encodeFragmentIdentifier");
  function F(e2) {
    if ("string" != typeof e2 || 1 !== e2.length) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function _(e2, t2) {
    return t2.encode ? t2.strict ? encodeURIComponent(e2).replaceAll(/[!'()*]/g, (e3) => `%${e3.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(e2) : e2;
  }
  function C(e2, t2) {
    return t2.decode ? x(e2) : e2;
  }
  function S(e2) {
    return Array.isArray(e2) ? e2.sort() : "object" == typeof e2 ? S(Object.keys(e2)).sort((e3, t2) => Number(e3) - Number(t2)).map((t2) => e2[t2]) : e2;
  }
  function A(e2) {
    const t2 = e2.indexOf("#");
    return -1 !== t2 && (e2 = e2.slice(0, t2)), e2;
  }
  function k(e2, t2, r2) {
    return "string" === r2 && "string" == typeof e2 ? e2 : "function" == typeof r2 && "string" == typeof e2 ? r2(e2) : !t2.parseBooleans || null === e2 || "true" !== e2.toLowerCase() && "false" !== e2.toLowerCase() ? "number" !== r2 || Number.isNaN(Number(e2)) || "string" != typeof e2 || "" === e2.trim() ? t2.parseNumbers && !Number.isNaN(Number(e2)) && "string" == typeof e2 && "" !== e2.trim() ? Number(e2) : e2 : Number(e2) : "true" === e2.toLowerCase();
  }
  function q(e2) {
    const t2 = (e2 = A(e2)).indexOf("?");
    return -1 === t2 ? "" : e2.slice(t2 + 1);
  }
  function I(e2, t2) {
    F((t2 = { decode: true, sort: true, arrayFormat: "none", arrayFormatSeparator: ",", parseNumbers: false, parseBooleans: false, types: /* @__PURE__ */ Object.create(null), ...t2 }).arrayFormatSeparator);
    const r2 = function(e3) {
      let t3;
      switch (e3.arrayFormat) {
        case "index":
          return (e4, r3, n3) => {
            t3 = /\[(\d*)]$/.exec(e4), e4 = e4.replace(/\[\d*]$/, ""), t3 ? (void 0 === n3[e4] && (n3[e4] = {}), n3[e4][t3[1]] = r3) : n3[e4] = r3;
          };
        case "bracket":
          return (e4, r3, n3) => {
            t3 = /(\[])$/.exec(e4), e4 = e4.replace(/\[]$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "colon-list-separator":
          return (e4, r3, n3) => {
            t3 = /(:list)$/.exec(e4), e4 = e4.replace(/:list$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "comma":
        case "separator":
          return (t4, r3, n3) => {
            const a2 = "string" == typeof r3 && r3.includes(e3.arrayFormatSeparator), o2 = "string" == typeof r3 && !a2 && C(r3, e3).includes(e3.arrayFormatSeparator);
            r3 = o2 ? C(r3, e3) : r3;
            const i2 = a2 || o2 ? r3.split(e3.arrayFormatSeparator).map((t5) => C(t5, e3)) : null === r3 ? r3 : C(r3, e3);
            n3[t4] = i2;
          };
        case "bracket-separator":
          return (t4, r3, n3) => {
            const a2 = /(\[])$/.test(t4);
            if (t4 = t4.replace(/\[]$/, ""), !a2) return void (n3[t4] = r3 ? C(r3, e3) : r3);
            const o2 = null === r3 ? [] : C(r3, e3).split(e3.arrayFormatSeparator);
            void 0 !== n3[t4] ? n3[t4] = [...n3[t4], ...o2] : n3[t4] = o2;
          };
        default:
          return (e4, t4, r3) => {
            void 0 !== r3[e4] ? r3[e4] = [...[r3[e4]].flat(), t4] : r3[e4] = t4;
          };
      }
    }(t2), n2 = /* @__PURE__ */ Object.create(null);
    if ("string" != typeof e2) return n2;
    if (!(e2 = e2.trim().replace(/^[?#&]/, ""))) return n2;
    for (const a2 of e2.split("&")) {
      if ("" === a2) continue;
      const e3 = t2.decode ? a2.replaceAll("+", " ") : a2;
      let [o2, i2] = P(e3, "=");
      void 0 === o2 && (o2 = e3), i2 = void 0 === i2 ? null : ["comma", "separator", "bracket-separator"].includes(t2.arrayFormat) ? i2 : C(i2, t2), r2(C(o2, t2), i2, n2);
    }
    for (const [e3, r3] of Object.entries(n2)) if ("object" == typeof r3 && null !== r3 && "string" !== t2.types[e3]) for (const [n3, a2] of Object.entries(r3)) {
      const o2 = t2.types[e3] ? t2.types[e3].replace("[]", "") : void 0;
      r3[n3] = k(a2, t2, o2);
    }
    else "object" == typeof r3 && null !== r3 && "string" === t2.types[e3] ? n2[e3] = Object.values(r3).join(t2.arrayFormatSeparator) : n2[e3] = k(r3, t2, t2.types[e3]);
    return false === t2.sort ? n2 : (true === t2.sort ? Object.keys(n2).sort() : Object.keys(n2).sort(t2.sort)).reduce((e3, t3) => {
      const r3 = n2[t3];
      return e3[t3] = Boolean(r3) && "object" == typeof r3 && !Array.isArray(r3) ? S(r3) : r3, e3;
    }, /* @__PURE__ */ Object.create(null));
  }
  function E(e2, t2) {
    if (!e2) return "";
    F((t2 = { encode: true, strict: true, arrayFormat: "none", arrayFormatSeparator: ",", ...t2 }).arrayFormatSeparator);
    const r2 = (r3) => t2.skipNull && null == e2[r3] || t2.skipEmptyString && "" === e2[r3], n2 = function(e3) {
      switch (e3.arrayFormat) {
        case "index":
          return (t3) => (r3, n3) => {
            const a3 = r3.length;
            return void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [_(t3, e3), "[", a3, "]"].join("")] : [...r3, [_(t3, e3), "[", _(a3, e3), "]=", _(n3, e3)].join("")];
          };
        case "bracket":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [_(t3, e3), "[]"].join("")] : [...r3, [_(t3, e3), "[]=", _(n3, e3)].join("")];
        case "colon-list-separator":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [_(t3, e3), ":list="].join("")] : [...r3, [_(t3, e3), ":list=", _(n3, e3)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator": {
          const t3 = "bracket-separator" === e3.arrayFormat ? "[]=" : "=";
          return (r3) => (n3, a3) => void 0 === a3 || e3.skipNull && null === a3 || e3.skipEmptyString && "" === a3 ? n3 : (a3 = null === a3 ? "" : a3, 0 === n3.length ? [[_(r3, e3), t3, _(a3, e3)].join("")] : [[n3, _(a3, e3)].join(e3.arrayFormatSeparator)]);
        }
        default:
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, _(t3, e3)] : [...r3, [_(t3, e3), "=", _(n3, e3)].join("")];
      }
    }(t2), a2 = {};
    for (const [t3, n3] of Object.entries(e2)) r2(t3) || (a2[t3] = n3);
    const o2 = Object.keys(a2);
    return false !== t2.sort && o2.sort(t2.sort), o2.map((r3) => {
      const a3 = e2[r3];
      return void 0 === a3 ? "" : null === a3 ? _(r3, t2) : Array.isArray(a3) ? 0 === a3.length && "bracket-separator" === t2.arrayFormat ? _(r3, t2) + "[]" : a3.reduce(n2(r3), []).join("&") : _(r3, t2) + "=" + _(a3, t2);
    }).filter((e3) => e3.length > 0).join("&");
  }
  function N(e2, t2) {
    var _a;
    t2 = { decode: true, ...t2 };
    let [r2, n2] = P(e2, "#");
    return void 0 === r2 && (r2 = e2), { url: ((_a = r2 == null ? void 0 : r2.split("?")) == null ? void 0 : _a[0]) ?? "", query: I(q(e2), t2), ...t2 && t2.parseFragmentIdentifier && n2 ? { fragmentIdentifier: C(n2, t2) } : {} };
  }
  function j(e2, t2) {
    t2 = { encode: true, strict: true, [T]: true, ...t2 };
    const r2 = A(e2.url).split("?")[0] || "";
    let n2 = E({ ...I(q(e2.url), { sort: false }), ...e2.query }, t2);
    n2 && (n2 = `?${n2}`);
    let a2 = function(e3) {
      let t3 = "";
      const r3 = e3.indexOf("#");
      return -1 !== r3 && (t3 = e3.slice(r3)), t3;
    }(e2.url);
    if ("string" == typeof e2.fragmentIdentifier) {
      const n3 = new URL(r2);
      n3.hash = e2.fragmentIdentifier, a2 = t2[T] ? n3.hash : `#${e2.fragmentIdentifier}`;
    }
    return `${r2}${n2}${a2}`;
  }
  function R(e2, t2, r2) {
    r2 = { parseFragmentIdentifier: true, [T]: false, ...r2 };
    const { url: n2, query: a2, fragmentIdentifier: o2 } = N(e2, r2);
    return j({ url: n2, query: v(a2, t2), fragmentIdentifier: o2 }, r2);
  }
  const D = Object.freeze(Object.defineProperty({ __proto__: null, exclude: function(e2, t2, r2) {
    return R(e2, Array.isArray(t2) ? (e3) => !t2.includes(e3) : (e3, r3) => !t2(e3, r3), r2);
  }, extract: q, parse: I, parseUrl: N, pick: R, stringify: E, stringifyUrl: j }, Symbol.toStringTag, { value: "Module" })), O = window.clayStorefrontConfig || {}, L = window.clayCustomerTags || [], U = window.clayMarketHandle, B = window.clayCountryCurrency, G = window.clayCountryIsoCode;
  function M() {
    return window.clayProductPriceConfig || {};
  }
  const Q = "clay-wholesale-hide-bundles", H = "clay-wholesale-styles", V = "clay-wholesale-pdp-block", z = "clay-wholesale-pdp-price-block", J = "clay-wholesale-atc-error", W = "clay-wholesale-qty", K = ".kaching-bundles__block", Y = ".product-block-buy-buttons", X = ".product-block-title", Z = 'form[action*="/cart/add"]';
  let ee = null, te = false, re = false;
  async function ne() {
    const e2 = m(window.location.href);
    e2 ? await async function(e3) {
      var _a, _b;
      let t2;
      try {
        t2 = await async function(e4) {
          const t3 = window.clayStorefrontConfig || {}, r3 = window.clayCustomerTier || {}, n3 = window.clayCustomerTags || [], a3 = window.clayCountryIsoCode, { allVariants: o3 } = await c(t3.shopDomain, t3.token, e4, "" === r3.customerGroupId ? "LOGGED_IN" : r3.customerGroupId, n3, a3);
          return o3;
        }(e3);
      } catch (e4) {
        return void ae();
      }
      if (!(t2 == null ? void 0 : t2.length)) return void ae();
      const r2 = new URL(window.location.href);
      let n2 = D.parse(r2.search).variant;
      const a2 = t2.find((e4) => e4.id === n2) || t2[0];
      if (!(a2 == null ? void 0 : a2.pricingRule)) return void ae();
      const o2 = (_b = (_a = a2.pricingRule) == null ? void 0 : _a.markets) == null ? void 0 : _b[0];
      if (!o2) return void ae();
      (function() {
        if (document.getElementById(Q)) return;
        const e4 = document.createElement("style");
        e4.id = Q, e4.textContent = `
    ${K},
    .product-block:has(${K}) {
      display: none !important;
    }
  `, document.head.appendChild(e4);
      })(), function(e4, t3, r3) {
        var _a2, _b2;
        const n3 = document.querySelector(Y);
        if (!n3) return;
        const a3 = function(e5, t4) {
          var _a3, _b3;
          if ("QUANTITY" !== ((_a3 = t4 == null ? void 0 : t4.pricing) == null ? void 0 : _a3.type)) return [];
          const r4 = M(), n4 = !!r4.showQuantity1Price, a4 = r4.quantityGridPriceDisplayText || "${{amount}}", o4 = t4.pricing.strategy, i3 = t4.pricing.priceSource, c3 = parseFloat(e5.price.amount), s3 = parseFloat(((_b3 = e5.compareAtPrice) == null ? void 0 : _b3.amount) || e5.price.amount), l3 = "R" === i3 ? c3 : s3;
          if (!l3 || isNaN(l3)) return [];
          const p3 = e5.price.currencyCode, u3 = t4.currency, y2 = window.marketConversionRate;
          let m2 = (t4.pricing.values || []).map((e6) => ({ quantity: String(e6.quantity), price: String(e6.price) })).filter((e6) => !isNaN(parseFloat(e6.quantity))).sort((e6, t5) => parseFloat(e6.quantity) - parseFloat(t5.quantity));
          u3 !== p3 && "" !== u3 && (y2 == null ? void 0 : y2.conversion_rate) && ["A", "F"].includes(o4) && (m2 = m2.map((e6) => ({ ...e6, price: (parseFloat(e6.price) * y2.conversion_rate).toFixed(2) })));
          m2 = m2.map((e6) => {
            let t5 = "A" === o4 ? e6.price : "P" === o4 ? (l3 * (1 - parseFloat(e6.price) / 100)).toFixed(2) : "F" === o4 ? (l3 - parseFloat(e6.price)).toFixed(2) : String(c3);
            return (parseFloat(t5) < 0 || parseFloat(t5) > c3) && (t5 = String(c3)), { ...e6, price: t5 };
          }), n4 || (m2 = m2.filter((e6) => !("1" === e6.quantity && parseFloat(e6.price) === c3)));
          return m2.map((e6, t5, r5) => {
            const n5 = t5 === r5.length - 1, o5 = r5[t5 + 1], i4 = n5 ? `${e6.quantity}+` : `${e6.quantity}–${parseFloat(o5.quantity) - 1}`, c4 = d(e6.price, a4), s4 = ((l3 - parseFloat(e6.price)) / l3 * 100).toFixed(0) + "%";
            return { qty: e6.quantity, range: i4, price: c4, discount: s4 };
          });
        }(e4, r3), o3 = 1, { retailPriceText: i2, compareAtPriceText: c2, savingsText: s2 } = y(e4, 0, o3), { savings: l2 } = function(e5, t4, r4) {
          let n4 = r4.pricing.strategy, a4 = r4.pricing.values, o4 = r4.currency, i3 = e5.price.currencyCode, c3 = "R" === r4.pricing.priceSource ? e5.price.amount : "C" === r4.pricing.priceSource ? e5.compareAtPrice.amount : e5.price.amount, s3 = window.marketConversionRate;
          if (!c3 || "" === c3) return { retailPrice: "", compareAtPrice: "", savings: "" };
          let l3 = a4.filter((e6) => Number(e6.quantity) <= t4).reduce((e6, t5) => Number(t5.quantity) > Number(e6.quantity) ? t5 : e6, { price: "0", quantity: "0" }).price;
          if (o4 !== i3 && "" !== o4) {
            if (!s3 || !s3.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
            ["A", "F"].includes(n4) && (l3 = (parseFloat(l3) * s3.conversion_rate).toFixed(2).toString());
          }
          let p3 = "A" === n4 ? l3 : "P" === n4 ? (parseFloat(c3) * (1 - parseFloat(l3) / 100)).toFixed(2).toString() : "F" === n4 ? (parseFloat(c3) - parseFloat(l3)).toFixed(2).toString() : e5.price.amount;
          if ("" === o4 && s3 && s3.base_currency !== i3) return { retailPrice: "", compareAtPrice: "", savings: "" };
          (parseFloat(p3) < 0 || parseFloat(p3) > parseFloat(e5.price.amount)) && (p3 = e5.price.amount);
          let u3 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c3) - parseFloat(p3)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c3) - parseFloat(p3)) / parseFloat(c3) * 100).toFixed(0) : 0;
          return { retailPrice: p3, compareAtPrice: parseFloat(c3).toFixed(2), savings: u3 };
        }(e4, o3, r3);
        if (!i2) return void ae();
        ee = { variantId: e4.id, handle: m(window.location.href) }, (_a2 = document.getElementById(z)) == null ? void 0 : _a2.remove(), (_b2 = document.getElementById(V)) == null ? void 0 : _b2.remove();
        const p2 = document.createElement("div");
        p2.id = z, p2.className = "app-clay-wholesale app-clay-wholesale--price-only product-block mt-5", p2.innerHTML = function({ retailPriceText: e5, compareAtPriceText: t4, savingsText: r4, savings: n4 }) {
          const a4 = M(), o4 = !(!a4.compareAtPriceDisplayText || "" === String(a4.compareAtPriceDisplayText).trim()), i3 = !(!a4.savingsDisplayText || "" === String(a4.savingsDisplayText).trim()) && ("amountPerUnit" === a4.savingsDisplayType || "percentage" === a4.savingsDisplayType) && ce(n4) && r4 && "" !== r4.trim(), c3 = o4 && ce(n4) && t4 && t4 !== e5, s3 = c3 ? `<span class="app-clay-wholesale__compare"><s>${t4}</s></span>` : "", l3 = i3 ? `<div class="app-clay-wholesale__savings">${r4}</div>` : "";
          return `
    <div class="app-clay-wholesale__price">
      <span class="app-clay-wholesale__retail">${e5}</span>
      ${s3}
    </div>
    ${l3}
  `;
        }({ retailPriceText: i2, compareAtPriceText: c2, savingsText: s2, savings: l2 });
        const u2 = document.querySelector(X);
        u2 && u2.parentNode ? u2.parentNode.insertBefore(p2, u2.nextSibling) : n3.parentNode.insertBefore(p2, n3);
        const g2 = document.createElement("div");
        g2.id = V, g2.className = "app-clay-wholesale product-block mt-5", g2.innerHTML = function({ tierRows: e5 }) {
          const t4 = function() {
            const e6 = M(), t5 = e6.quantityGridTemplate || "quantityRangePrice", r5 = e6.quantityGridHeaderText || {};
            switch (t5) {
              case "quantityPrice":
              default:
                return { headers: [r5.header1 || "Quantity", r5.header2 || "Price"], cells: [(e7) => e7.qty, (e7) => e7.price] };
              case "quantityRangePrice":
                return { headers: [r5.header1 || "Quantity Range", r5.header2 || "Price"], cells: [(e7) => e7.range, (e7) => e7.price] };
              case "quantityRangeDiscount":
                return { headers: [r5.header1 || "Quantity Range", r5.header2 || "Discount"], cells: [(e7) => e7.range, (e7) => e7.discount] };
              case "quantityBuyPrice":
                return { headers: [r5.header1 || "Quantity", r5.header2 || "Price"], cells: [(e7) => `Buy ${e7.qty}`, (e7) => e7.price] };
              case "quantityPriceDiscount":
                return { headers: [r5.header1 || "Quantity", r5.header2 || "Price", r5.header3 || "Discount"], cells: [(e7) => `${e7.qty}+`, (e7) => e7.price, (e7) => e7.discount] };
            }
          }(), r4 = e5.length ? `
      <table class="app-clay-wholesale__tiers">
        <thead>
          <tr>${t4.headers.map((e6) => `<th>${e6}</th>`).join("")}</tr>
        </thead>
        <tbody>
          ${e5.map((e6) => `<tr>${t4.cells.map((t5) => `<td>${t5(e6)}</td>`).join("")}</tr>`).join("")}
        </tbody>
      </table>
    ` : "";
          return `
    ${r4}
    <div class="app-clay-wholesale__qty-block">
      <div class="app-clay-wholesale__qty-heading">Quantity</div>
      <div class="app-clay-wholesale__qty-pill" role="group" aria-label="Quantity">
        <button type="button" class="app-clay-wholesale__qty-btn" data-qty-step="-1" aria-label="Decrease quantity">−</button>
        <input
          id="${W}"
          class="app-clay-wholesale__qty-input"
          type="number"
          inputmode="numeric"
          min="1"
          value="1"
          aria-label="Quantity"
        />
        <button type="button" class="app-clay-wholesale__qty-btn" data-qty-step="1" aria-label="Increase quantity">+</button>
      </div>
    </div>
  `;
        }({ tierRows: a3 }), n3.parentNode.insertBefore(g2, n3), function() {
          if (document.getElementById(H)) return;
          const e5 = document.createElement("style");
          e5.id = H, e5.textContent = `
    .app-clay-wholesale { font-family: inherit; }
    .app-clay-wholesale__price { display: flex; align-items: baseline; gap: 8px; font-size: 1.5rem; font-weight: 700; }
    .app-clay-wholesale__compare { font-weight: 400; opacity: 0.6; font-size: 1rem; }
    .app-clay-wholesale__savings { margin-top: 4px; font-size: 0.95rem; }
    .app-clay-wholesale__tiers {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      margin-top: 0;
      font-size: 1rem;
      border: 2px solid currentColor;
      border-radius: 8px;
      overflow: hidden;
    }
    .app-clay-wholesale__tiers th,
    .app-clay-wholesale__tiers td {
      padding: 10px 12px;
      text-align: left;
      border: 0;
    }
    .app-clay-wholesale__tiers th + th,
    .app-clay-wholesale__tiers td + td { border-left: 2px solid currentColor; }
    .app-clay-wholesale__tiers thead th { border-bottom: 2px solid currentColor; }
    .app-clay-wholesale__tiers tbody tr + tr td { border-top: 2px solid currentColor; }
    .app-clay-wholesale__tiers th { font-weight: 700; }
    .app-clay-wholesale__qty-block { margin-top: 16px; }
    .app-clay-wholesale__qty-heading { font-size: 1rem; margin-bottom: 8px; }
    .app-clay-wholesale__qty-pill {
      display: inline-flex;
      align-items: stretch;
      border: 2px solid currentColor;
      border-radius: 6px;
      overflow: hidden;
      width: 200px;
      max-width: 100%;
    }
    .app-clay-wholesale__qty-btn {
      flex: 0 0 48px;
      background: transparent;
      border: 0;
      font-size: 1.25rem;
      line-height: 1;
      cursor: pointer;
      color: inherit;
      padding: 10px 0;
    }
    .app-clay-wholesale__qty-btn:hover { background: rgba(0,0,0,0.05); }
    .app-clay-wholesale__qty-input {
      flex: 1 1 auto;
      min-width: 0;
      border: 0;
      background: transparent;
      text-align: center;
      font-size: 1.1rem;
      font-weight: 600;
      color: inherit;
      padding: 8px 4px;
      -moz-appearance: textfield;
    }
    .app-clay-wholesale__qty-input::-webkit-outer-spin-button,
    .app-clay-wholesale__qty-input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .app-clay-wholesale__qty-input:focus { outline: none; }
    .app-clay-wholesale__atc-error {
      margin-top: 12px;
      padding: 0;
      border: 0;
      background: transparent;
      border-radius: 0;
      color: #d4232c;
      font-size: 0.95rem;
      line-height: 1.35;
    }
    [${oe}] {
      background: transparent !important;
      color: #d4232c !important;
      border: 0 !important;
      padding: 0 !important;
      border-radius: 0 !important;
    }
  `, document.head.appendChild(e5);
        }(), function() {
          const e5 = document.getElementById(V);
          if (!e5) return;
          const t4 = e5.querySelector(`#${W}`);
          if (!t4) return;
          e5.querySelectorAll("[data-qty-step]").forEach((e6) => {
            e6.addEventListener("click", () => {
              const r4 = parseInt(e6.getAttribute("data-qty-step"), 10) || 0, n4 = parseInt(t4.value, 10) || 1, a4 = Math.max(1, n4 + r4);
              t4.value = String(a4);
            });
          }), t4.addEventListener("change", () => {
            const e6 = parseInt(t4.value, 10);
            (isNaN(e6) || e6 < 1) && (t4.value = "1");
          });
        }();
      }(a2, 0, o2);
    }(e2) : ae();
  }
  function ae() {
    var _a, _b, _c, _d;
    ee = null, (_a = document.getElementById(Q)) == null ? void 0 : _a.remove(), (_b = document.getElementById(z)) == null ? void 0 : _b.remove(), (_c = document.getElementById(V)) == null ? void 0 : _c.remove(), (_d = document.getElementById(J)) == null ? void 0 : _d.remove();
  }
  console.warn("[clay-wholesale] bundle loaded", { href: window.location.href, hasConfig: !!window.clayStorefrontConfig, customerTier: window.clayCustomerTier }), window.__clayWholesaleLoaded = true, async function() {
    !function() {
      if (re) return;
      re = true;
      const e2 = window.fetch;
      window.fetch = async function(...t2) {
        const [r2] = t2;
        let n2 = "";
        try {
          n2 = "string" == typeof r2 ? r2 : (r2 == null ? void 0 : r2.url) || ((r2 == null ? void 0 : r2.toString) ? r2.toString() : "");
        } catch (e3) {
        }
        const a2 = /\/cart\/add(\.js)?(\?|$)/.test(n2);
        let o2;
        try {
          o2 = await e2.apply(this, t2);
        } catch (e3) {
          throw a2 && (console.warn("[clay-wholesale] /cart/add network failure", e3), ie("Unable to add to cart. Please try again.")), e3;
        }
        if (a2 && !o2.ok) try {
          const e3 = o2.clone(), t3 = await e3.json(), r3 = (t3 == null ? void 0 : t3.description) || (t3 == null ? void 0 : t3.message) || "";
          console.warn("[clay-wholesale] /cart/add error caught by fetch wrapper", { status: o2.status, message: r3, body: t3 }), r3 && ie(r3);
        } catch (e3) {
          console.warn("[clay-wholesale] failed to parse /cart/add error body", e3), ie("Unable to add to cart. Please try again.");
        }
        return o2;
      }, console.warn("[clay-wholesale] fetch interceptor attached");
    }(), await async function() {
      fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { customer_tags: (L == null ? void 0 : L.join(",")) || "" } }) }).catch(() => {
      });
      let e2 = null;
      try {
        const t2 = await (async (e3, t3, r2) => {
          var _a, _b, _c, _d, _e, _f, _g, _h;
          let n2 = null, a2 = null, o2 = null, c2 = null;
          try {
            const s2 = await i({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts($country: CountryCode) @inContext(country: $country) {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }", variables: { country: r2 } });
            ((_c = (_b = (_a = s2 == null ? void 0 : s2.data) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) == null ? void 0 : _c.length) > 0 && (n2 = (_d = s2.data.products.edges[0].node.variants) == null ? void 0 : _d.edges[0].node.price);
            const l2 = await i({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }" });
            if (((_g = (_f = (_e = l2 == null ? void 0 : l2.data) == null ? void 0 : _e.products) == null ? void 0 : _f.edges) == null ? void 0 : _g.length) > 0 && (a2 = (_h = l2.data.products.edges[0].node.variants) == null ? void 0 : _h.edges[0].node.price), n2 && a2) {
              const e4 = a2.currencyCode;
              e4 !== n2.currencyCode && (c2 = (parseFloat(n2.amount) / parseFloat(a2.amount)).toFixed(8), o2 = e4);
            }
            return { conversionRate: c2, baseCurrency: o2 };
          } catch (e4) {
            return console.error("Error fetching conversion rate:", e4), { conversionRate: null, baseCurrency: null };
          }
        })(O.shopDomain, O.token, G);
        (t2 == null ? void 0 : t2.conversionRate) && (e2 = { conversion_rate: t2.conversionRate, base_currency: t2.baseCurrency, market_handle: U, market_currency: B });
      } catch (e3) {
      }
      window.marketConversionRate = e2, e2 && fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { market_conversion_rate: JSON.stringify(e2) } }) }).catch(() => {
      });
    }(), function() {
      if (te) return;
      te = true, console.log("[clay-wholesale] attachAtcInterceptor: attached"), document.addEventListener("click", async (e2) => {
        const t2 = e2.target;
        if (!t2 || !t2.closest) return;
        const r2 = t2.closest(Z), n2 = t2.closest('button[type="submit"], input[type="submit"]'), a2 = t2.closest(".product-block-buy-buttons"), o2 = t2.closest(".product-block-atc-style"), i2 = n2 && (a2 || o2 || r2);
        if (n2 && console.log("[clay-wholesale] click on submit element", { submitEl: n2, inBuyButtons: !!a2, inAtcStyle: !!o2, inForm: !!r2, isAtc: !!i2, insideWholesaleBlock: !!t2.closest(`#${V}`), activeWholesaleState: ee }), !ee) return;
        if (!i2) return;
        if (t2.closest(`#${V}`)) return;
        e2.preventDefault(), e2.stopImmediatePropagation();
        const c2 = document.getElementById(W), s2 = Math.max(1, parseInt(c2 == null ? void 0 : c2.value, 10) || 1), l2 = function(e3) {
          if (!e3) return null;
          const t3 = String(e3), r3 = t3.match(/(\d+)$/);
          return r3 ? r3[1] : t3;
        }(ee.variantId);
        if (console.log("[clay-wholesale] ATC intercepted", { qty: s2, variantId: ee.variantId, numericVariantId: l2 }), !l2) return void console.warn("[clay-wholesale] no numericVariantId, aborting");
        const p2 = n2, u2 = p2 == null ? void 0 : p2.disabled;
        p2 && (p2.disabled = true), function() {
          const e3 = document.getElementById(J);
          e3 && (e3.textContent = "", e3.style.display = "none");
          document.querySelectorAll(`[${oe}]`).forEach((e4) => {
            e4.textContent = "";
          });
        }();
        try {
          const e3 = await fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(l2), quantity: s2 }] }) });
          if (console.log("[clay-wholesale] /cart/add.js response", { status: e3.status, ok: e3.ok }), !e3.ok) {
            let t3 = "", r3 = null;
            try {
              r3 = await e3.json(), t3 = (r3 == null ? void 0 : r3.description) || (r3 == null ? void 0 : r3.message) || "";
            } catch (e4) {
              console.warn("[clay-wholesale] failed to parse error body", e4);
            }
            throw console.log("[clay-wholesale] error body", { parsedBody: r3, errorText: t3 }), new Error(t3);
          }
          console.log("[clay-wholesale] add succeeded — opening drawer"), function() {
            var _a, _b;
            document.dispatchEvent(new CustomEvent("theme:update:cart")), document.dispatchEvent(new CustomEvent("theme:open:cart-drawer"));
            try {
              const e4 = (_b = (_a = window.Alpine) == null ? void 0 : _a.store) == null ? void 0 : _b.call(_a, "modals");
              e4 && e4.modals && e4.modals.cart && e4.open("cart");
            } catch (e4) {
            }
          }();
        } catch (e3) {
          const t3 = "Unable to add to cart. Please try again.", r3 = e3 && e3.message ? e3.message : t3;
          console.log("[clay-wholesale] showing ATC error:", r3), ie(r3 || t3);
        } finally {
          p2 && (p2.disabled = u2 || false);
        }
      }, true);
    }(), function() {
      window.addEventListener("popstate", ne);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), ne();
      };
      const t2 = history.replaceState;
      history.replaceState = function() {
        t2.apply(this, arguments), ne();
      }, "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", ne) : ne();
    }();
  }();
  const oe = "data-clay-error-slot";
  function ie(e2) {
    if (!e2) return;
    console.warn("[clay-wholesale] showAtcError called:", e2);
    const t2 = document.querySelectorAll(`[x-text="cartAddErrorMessage"], [${oe}]`);
    t2.forEach((t3) => {
      t3.setAttribute(oe, ""), t3.hasAttribute("x-text") && t3.removeAttribute("x-text"), t3.textContent = e2;
    }), t2.length && console.warn("[clay-wholesale] populated theme cartAddErrorMessage slot(s)", t2.length);
    const r2 = document.querySelector(Y);
    if (r2 && r2.parentNode) {
      let t3 = document.getElementById(J);
      t3 || (t3 = document.createElement("div"), t3.id = J, t3.className = "app-clay-wholesale__atc-error", t3.setAttribute("role", "alert"), r2.parentNode.insertBefore(t3, r2.nextSibling)), t3.textContent = e2, t3.style.display = "";
    } else t2.length || console.warn("[clay-wholesale] no insertion target for ATC error");
  }
  function ce(e2) {
    if (null == e2 || "" === e2) return false;
    const t2 = parseFloat(e2);
    return !isNaN(t2) && t2 > 0;
  }
}();
